import { number, object, string } from 'yup'

export interface IAcceptanceCapSchema {
  acceptanceCapCadence: string
  acceptanceCap: number
}

export const AcceptanceCapSchema = object<IAcceptanceCapSchema>({
  acceptanceCapCadence: string().required(),
  acceptanceCap: number()
    .required()
    .min(0)
    .typeError('Acceptance Cap must be a non-negative number'),
})
